import {
    SmsCampaignState,
    SmsCampaignType,
} from "../features/smsCampaign/smsCampaignSlice/SmsCampaignSlice";

export function ValidateSmsCampaignTemplate(
    state: SmsCampaignState
): string | null {
    if (state.definition.template) {
        return null;
    }
    return "متن پیامک وارد نشده است";
}

export function ValidateSmsCampaignProjectFilter(
    state: SmsCampaignState
): string | null {
    if (state.projectFilter.targetAccessId === null) {
        return "لطفا یک دسترسی انتخاب کنید";
    }

    return null;
}

export function ValidateSmsCampaignExcelFile(
    state: SmsCampaignState
): string | null {
    if (state.excelFile === null || state.excelFile?.fileId === null) {
        return "لطفا یک فایل اکسل وارد کنید";
    }

    return null;
}

export function ValidateSmsCampaignSettingStage(
    state: SmsCampaignState
): string | null {
    if (state.definition.gatewayNumberId === null) {
        return "سرشماره انتخاب نشده است";
    }

    if (
        state.mobileNumbers.length === 0 &&
        state.smsCampaignType === SmsCampaignType.CampaignWithTestMobileNumbers
    ) {
        return "لطفا حداقل یک شماره وارد کنید";
    }

    return null;
}
